import { render, staticRenderFns } from "./CustomersCategoryEditor.vue?vue&type=template&id=57281172"
import script from "./CustomersCategoryEditor.vue?vue&type=script&lang=js"
export * from "./CustomersCategoryEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports